/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Searchform_Noresults2Inputs */

const id_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada hasil ditemukan`)
};

const ms_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada hasil ditemui`)
};

const da_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater fundet`)
};

const de_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse gefunden`)
};

const en_us2_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const es_es2_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

const es_mx2_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

const fil_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang resulta`)
};

const fr_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat trouvé`)
};

const it_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato`)
};

const hu_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs találat`)
};

const nl_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten gevonden`)
};

const no_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater funnet`)
};

const pl_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono wyników`)
};

const pt_br2_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const pt_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado`)
};

const ro_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit rezultate`)
};

const fi_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tuloksia`)
};

const sv_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga resultat hittades`)
};

const vi_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy kết quả`)
};

const tr_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç bulunamadı`)
};

const cs_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné výsledky`)
};

const bg_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени резултати`)
};

const ru_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты не найдены`)
};

const uk_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результатів не знайдено`)
};

const ar_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على نتائج`)
};

const hi_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई परिणाम नहीं मिला`)
};

const th_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบผลลัพธ์`)
};

const ja_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果が見つかりません`)
};

const zh_cn2_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const zh_hant1_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const ko_components_searchform_noresults2 = /** @type {(inputs: Components_Searchform_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {Components_Searchform_Noresults2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_searchform_noresults2 = /** @type {((inputs?: Components_Searchform_Noresults2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Searchform_Noresults2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_searchform_noresults2(inputs)
	if (locale === "ms") return ms_components_searchform_noresults2(inputs)
	if (locale === "da") return da_components_searchform_noresults2(inputs)
	if (locale === "de") return de_components_searchform_noresults2(inputs)
	if (locale === "en-US") return en_us2_components_searchform_noresults2(inputs)
	if (locale === "es-ES") return es_es2_components_searchform_noresults2(inputs)
	if (locale === "es-MX") return es_mx2_components_searchform_noresults2(inputs)
	if (locale === "fil") return fil_components_searchform_noresults2(inputs)
	if (locale === "fr") return fr_components_searchform_noresults2(inputs)
	if (locale === "it") return it_components_searchform_noresults2(inputs)
	if (locale === "hu") return hu_components_searchform_noresults2(inputs)
	if (locale === "nl") return nl_components_searchform_noresults2(inputs)
	if (locale === "no") return no_components_searchform_noresults2(inputs)
	if (locale === "pl") return pl_components_searchform_noresults2(inputs)
	if (locale === "pt-BR") return pt_br2_components_searchform_noresults2(inputs)
	if (locale === "pt") return pt_components_searchform_noresults2(inputs)
	if (locale === "ro") return ro_components_searchform_noresults2(inputs)
	if (locale === "fi") return fi_components_searchform_noresults2(inputs)
	if (locale === "sv") return sv_components_searchform_noresults2(inputs)
	if (locale === "vi") return vi_components_searchform_noresults2(inputs)
	if (locale === "tr") return tr_components_searchform_noresults2(inputs)
	if (locale === "cs") return cs_components_searchform_noresults2(inputs)
	if (locale === "bg") return bg_components_searchform_noresults2(inputs)
	if (locale === "ru") return ru_components_searchform_noresults2(inputs)
	if (locale === "uk") return uk_components_searchform_noresults2(inputs)
	if (locale === "ar") return ar_components_searchform_noresults2(inputs)
	if (locale === "hi") return hi_components_searchform_noresults2(inputs)
	if (locale === "th") return th_components_searchform_noresults2(inputs)
	if (locale === "ja") return ja_components_searchform_noresults2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_searchform_noresults2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_searchform_noresults2(inputs)
	return ko_components_searchform_noresults2(inputs)
});
export { components_searchform_noresults2 as "components.searchForm.noResults" }